import { loadUsers } from '../api';

// Función para obtener usuarios desde la API
export const getUsers = async () => {
  try {
    const users = await loadUsers();
    // Format user names consistently
    return users.map(user => ({
      ...user,
      fullName: `${user.firstName} ${user.lastName}`.trim()
    }));
  } catch (error) {
    console.error('Error al cargar usuarios:', error);
    return [];
  }
};

// Función para obtener un usuario por email
export const getUserByEmail = async (email) => {
  try {
    const users = await loadUsers();
    return users.find(user => user.email === email) || null;
  } catch (error) {
    console.error('Error al buscar usuario:', error);
    return null;
  }
};

// Exportar por defecto
export default {
  getUsers,
  getUserByEmail
};
